import { Injectable } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database-deprecated';
import { database } from 'firebase';
import { Observable } from 'rxjs/Observable';
import { ReplaySubject } from 'rxjs/ReplaySubject';

import { AuthService } from '../../core/auth.service';
import { ServiceBase } from '../../shared/base/service-base';
import { UserService } from '../../users/shared/user.service';

import { Course } from './course';
import { CourseUserService } from './course-user.service';
import {Syllabus} from "../../syllabuses/shared/syllabus";

@Injectable()
export class CourseService extends ServiceBase<Course> {
  static path = '/courses';

  visibleCourses$: Observable<Course[]>;

  private filter$: ReplaySubject<any> = new ReplaySubject(1);
  private filteredCourses$: FirebaseListObservable<Course[]>;

  constructor(db: AngularFireDatabase,
    private auth: AuthService,
    private courseUserService: CourseUserService,
    private userService: UserService) {
    super(db, CourseService.path);

    this.filteredCourses$ = db.list(CourseService.path, {query: {
      orderByChild: 'status',
      equalTo: this.filter$
    }}).map(items => items.sort((a, b) => {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })) as FirebaseListObservable<Course[]>;

    this.visibleCourses$ = this.filter$
      .switchMap(filter => {
        return this.userService.attachField(this.filteredCourses$, 'owner', 'ownerObservable');
      });
  }

  filterStatus(filter: string): void {
    switch (filter) {
      case 'READY':
        this.filter$.next('READY');
        break;
      case 'INPROGRESS':
        this.filter$.next('INPROGRESS');
        break;
      case 'CLOSE':
        this.filter$.next('CLOSE');
        break;
      default:
        this.filter$.next('INPROGRESS');
        break;
    }
  }

  push(value: Course) {
    return super.push(Object.assign(new Course(), {
      owner: this.auth.auth.uid
    }, value));
  }

  async create(value: Course) {
    const course: database.ThenableReference = await this.push(value);
    await this.addUser(course);
    return course;
  }

  private addUser({ key }) {
    return this.courseUserService.readUser({ $key: key }).set({ state: true });
  }


}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/shared/course.service.ts